import React from "react";
import { SectionProgressType } from "src/pages/DigestPage/DigestDetails";

interface DigestSectionProgressBarProps {
  sectionProgress: SectionProgressType;
}

export default function DigestSectionProgressBar({
  sectionProgress,
}: DigestSectionProgressBarProps) {
  const { activeSectionIndex, totalSections, sectionName } = sectionProgress;
  const progressPercent =
    totalSections > 0
      ? ((activeSectionIndex + 0.5) / totalSections) * 100
      : 0;

  return (
    <div className="px-5 py-3 border-b border-border/50">
      <div className="flex items-center justify-between text-sm text-muted-foreground mb-1.5">
        <span>
          Section {activeSectionIndex + 1} of {totalSections} running
          {sectionName ? `: ${sectionName}` : ""}
        </span>
      </div>
      <div className="h-1.5 bg-border/50 rounded-full overflow-hidden">
        <div
          className="h-full bg-primary rounded-full transition-all duration-500 ease-out"
          style={{ width: `${progressPercent}%` }}
        />
      </div>
    </div>
  );
}
